import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardBody,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { axiosRequest } from "../../../redux/utils/axios-utils";
import AddReplyContain from "../AddReply";
import AddReviewContain from "../AddReview";
const AddReviewContainer = (props) => {
  const [studentReview, setStudentReview] = useState([]);
  const [myReview, setMyReview] = useState([]);
  const [ratings, setRatings] = useState({});
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const { user: fromUserId } = useSelector((state) => state.auth);

  const getReviews = async () => {
    var res = await axiosRequest({
      url: "/newTuition/getReviews/" + props.data.tuitionId,
      method: "get",
    });
    if (res.data) {
      setRatings(res.data[0].ratings);
      var studentReview1 = res.data[0]?.reviews?.filter(
        (t) =>
          (t.fromUserId === props.data.studentId &&
            t.parentReviewId === null) ||
          (t.fromUserId === fromUserId && t.parentReviewId !== null)
      );

      var myReview1 = res.data[0]?.reviews?.filter(
        (t) =>
          (t.fromUserId === fromUserId && t.parentReviewId === null) ||
          (t.fromUserId === props.data.studentId && t.parentReviewId !== null)
      );
      setStudentReview(studentReview1);
      setMyReview(myReview1);
    }
  };

  useEffect(() => {
    getReviews();
  }, []);

  return (
    <Fragment>
      <ModalHeader toggle={props.toggler}>
        {props.title} to {props.data.studentName}
      </ModalHeader>
      <ModalBody className={"pb-0 " + props.bodyClass}>
        <Col sm="12" xl="12 box-col-12">
          <Card className="mb-0">
            <CardBody className="megaoptions-border-space-sm py-1">
              <AddReplyContain
                data={studentReview}
                name={props.data.studentName}
                stThumb={props.data.studentThumb}
                trThumb={props.data.tutorThumb}
                fromUserId={fromUserId}
                studentId={props.data.studentId}
                tuitionId={props.data.tuitionId}
                isTutor={true}
                isStudent={false}
                ratings={ratings}
              />
              <AddReviewContain
                data={myReview}
                name={props.data.studentName}
                stThumb={props.data.studentThumb}
                trThumb={props.data.tutorThumb}
                fromUserId={fromUserId}
                studentId={props.data.studentId}
                tuitionId={props.data.tuitionId}
                isTutor={true}
                isStudent={false}
                ratings={ratings}
              />
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: "warning", onClick: props.toggler }}>Close</Btn>
      </ModalFooter>
    </Fragment>
  );
};

export default AddReviewContainer;
